import React from "react";
import { useTranslation } from "react-i18next";
import GreyChip from "./grey-chip";

export default function NoAssetChip() {
	const { t } = useTranslation();
	return <GreyChip>{t("elements.device_select.no_asset")}</GreyChip>;
}
